/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2022-12-05 17:52:11
 * @LastEditors: changfeng
 * @LastEditTime: 2023-01-09 18:34:39
 */
export default {
  'table.accountName': '账号名称',
  'table.accountAdvertise': '广告账户',
  'table.accountBind': '绑定账号',
  'table.accountRefresh': '刷新账户',
  'table.account.title': '标题',
  'table.operation': '操作',
  'table.breadcrums.createStrategy': '新建策略',
  'table.log.columns.advertiseID': '广告ID',
  'table.log.columns.strategy': '策略',
  'table.log.columns.strategyID': '策略ID',
  'table.log.columns.shareCode': '分享码',

  'table.log.columns.fixTime': '修改时间',
  'table.log.columns.remark': '备注',

  'table.template.columns.templateName': '模板名称',
};
